import axios from 'axios';
const storageName = 'sdv.user';
const storageKey = 'isNavDisabled';
const storageCheckout = 'needsCheckout';
const storagePreviousURL = 'previousURL';

const state = {
  user: {},
  accessLevel: null,
  isNavDisabled:  JSON.parse(localStorage.getItem(storageKey)) || null,
  needsCheckout: JSON.parse(localStorage.getItem(storageCheckout)) || false,
  previousURL: JSON.parse(localStorage.getItem(storagePreviousURL)) || ''
};

const getters = {
  getNeedsCheckout: (state) => state.needsCheckout,
  getPreviousURL: (state) => state.previousURL,
  getUser(state) {
    // updateUserFromStorage(state);
    return state.user;
  },
  getNavDisabledStatus(state) {
    return state.isNavDisabled;
  },
  getJWT(state) {
    // updateUserFromStorage(state);
    return state.user.token;
  },
  getAccessLevel(state) {
    let account = state.user.account;
    return (
      state.accessLevel ||
      (account && account.subscription.plan.features) ||
      null
    );
  }
};

const actions = {
  async fetchUser({ commit }) {
    try {
      const response = await axios.get('/api/users/me');
      commit('setUser', response.data);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  }
};

const mutations = {
  setNeedsCheckout(state, data) {
    state.needsCheckout = data;
    localStorage.setItem(storageCheckout, JSON.stringify(data));
  },
  setPreviousURL(state, data) {
    state.previousURL = data;
    localStorage.setItem(storagePreviousURL, JSON.stringify(data));
  }, 
  setNavDisabled(state, data) {
    state.isNavDisabled = data;
    localStorage.setItem(storageKey, JSON.stringify(data));
  },
  setUser(state, data) {
    // sessionStorage.setItem(storageName, JSON.stringify(data));
    let features =
      (data.account &&
        data.account.subscription &&
        data.account.subscription.plan &&
        data.account.subscription.plan.features) ||
      {};
    state.user = data;
    state.accessLevel = features;
  },
  logout(state) {
    localStorage.removeItem(storageKey);
    sessionStorage.removeItem(storageName);
    state.user = {};
    state.accessLevel = null;
  }
};

// function updateUserFromStorage(state) {
//   let storageUser = JSON.parse(sessionStorage.getItem(storageName));
//   if (!state.user._id && storageUser) {
//     state.user = storageUser;
//   }
// }

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
